import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import ScrollToTop from './components/base/ScrollToTop.tsx'
import MarianaTekAfterNavigate from './components/base/MarianaTekAfterNavigate.tsx'

function App() {
    return (
        <BrowserRouter basename={__BASE_PATH__}>
            <ScrollToTop />
            <MarianaTekAfterNavigate />
            <AppRoutes />
        </BrowserRouter>
    )
}

export default App